/**
 * @generated SignedSource<<a4454a09c96027d7ac58e0df1830597b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraWorkManagementUserLicenseSeatEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ActionsCell900BadPattern$data = {
  readonly jwmLicensing: {
    readonly currentUserSeatEdition: JiraWorkManagementUserLicenseSeatEdition | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ActionsCell900BadPattern";
};
export type ActionsCell900BadPattern$key = {
  readonly " $data"?: ActionsCell900BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionsCell900BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ActionsCell900BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraWorkManagementLicensing",
      "kind": "LinkedField",
      "name": "jwmLicensing",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "currentUserSeatEdition"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "6db719c98ede2a17a9f054770c216964";

export default node;
